import { writable } from "svelte/store";
import ModelType from "../../Models/ModelType";
const InfoCardStore = {
	meta: {
		lastUpdated: writable(new Date(0))
	},
	model: writable(null),
	modelType: writable(ModelType.VESSEL),
	element: writable(null),
	visible: writable(false),
	actions: {
		setModel: (model) => {
			InfoCardStore.visible.set(false);

			InfoCardStore.modelType.set(model.type);
			InfoCardStore.model.set(model);
			InfoCardStore.visible.set(true);
			InfoCardStore.meta.lastUpdated.set(Date.now());
		},
		close: () => {
			InfoCardStore.visible.set(false);
		}
	}
};
export default InfoCardStore;
